<template>
  <div>
    <h5 v-html="$t('filter.titles.' + key)" />
    <b-input-group>
      <b-input-group-text>
        <font-awesome-icon :icon="icon" />
      </b-input-group-text>
      <multiselect
        class="custom-select"
        v-model="selected"
        :options="regions"
        :multiple="true"
        :placeholder="$t(tKey + 'placeholder')"
        :closeOnSelect="false"
        :allowEmpty="false"
        :searchable="true"
        group-label="wholeRegion"
        group-values="regions"
        :group-select="true"
        selectLabel=""
        :selectGroupLabel="$t(tKey + 'grpSelect')"
        deselectLabel=""
        :deselectGroupLabel="$t(tKey + 'grpDeselect')"
        selectedLabel=""
        label="text"
        track-by="value"
        @input="transmitNewValue()"
        :disabled="active"
      >
        <template slot="selection" slot-scope="{ values }">
          <div v-if="values.length">
            <small
              class="multiselect__single"
              v-if="values.length > 1"
              v-html="
                `${values.length} ${$tc(tKey + 'selected', values.length)}`
              "
            />
            <small class="multiselect__single" v-else v-html="values[0].text" />
          </div>
        </template>
      </multiselect>
    </b-input-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    propKey: { type: String, default: null },
    active: { type: Boolean, default: false },
  },
  data() {
    return {
      tKey: "filter.region.",
      selected: 95,
      icon: "map-marker-alt",
      key: "region",
    };
  },
  created() {
    this.getDefaultRegion();
    this.key = this.propKey ? this.propKey : this.key;
    this.transmitNewValue();
  },
  computed: {
    ...mapGetters("regions", ["regions"]),
  },
  methods: {
    getDefaultRegion() {
      this.selected = [{ text: "Tourismusregion Zürich", value: 95 }];
    },
    transmitNewValue() {
      if (!this.selected.length) this.getDefaultRegion();
      this.$emit("transmit", this.selected, this.key);
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.multiselect {
  min-height: 0 !important;
  box-sizing: border-box !important;
}
.multiselect__placeholder,
.multiselect__single {
  margin: 0 !important;
}
.multiselect__tags {
  border: none !important;
  min-height: 0 !important;
  padding: 0 !important;
}
.multiselect__select {
  display: none !important;
}
.multiselect__content-wrapper {
  /* width */
  &::-webkit-scrollbar {
    width: 4px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px lightgray;
    border-radius: 0px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: $colorbase-dark;
    border-radius: 10px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: $colorbase;
  }
}
</style>
